<script>
    import { itemStore } from '../../store/items';

    import AccordionItem from './item.svelte';
    import { lastSearchStore, SEARCH_TYPES } from '../../util/search';

    let visibleItems = false;
    let lastSearchType;

    itemStore.subscribeVisible((visible) => {
        visibleItems = visible;
    });

    lastSearchStore.subscribe(({ type }) => {
        lastSearchType = type;
    });

</script>

{#if visibleItems === false}
    <p class="ghwp-faq__results-intro ghwp-faq__results-intro--none">
        Keine Ergebnisse
    </p>
{:else}
    {#if lastSearchType === SEARCH_TYPES.FULLTEXT}
        <p class="ghwp-faq__results-intro">
            Hier finden Sie ihre Suchergebnisse:
        </p>
    {/if}
    <ul class="ghwp-accordion">
        {#each visibleItems as item}
            {#key item}
                <AccordionItem {item} />
            {/key}
        {/each}
    </ul>
{/if}
